import {
  Button,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalWindow,
  Search,
} from "@cxc/react-fpds-components";
import * as React from "react";
import { useState } from "react";
import { AemButton, AemFeatureText } from "../../clients/AEMTypes";
import { removeAllHtmlTags } from "../../utils";
import useAem from "../ApiRetrieval/useAem";
import { DropdownContainer, MinimalDealer } from "./DealerTypes";

export interface DealerLookupModalProps {
  dealers: MinimalDealer[];
  setDealerExternalId: (val: string) => void;
  dealerExternalId: string;
  aemBaseUrl: string;
}

interface IValue {
  inputValue: string;
  selectedValue: string;
}

interface Hit {
  label: string;
  value: string;
  subText?: string;
}

interface HitGroup {
  label?: string;
  hits: Hit[];
}

export const DealerLookupModal: React.FC<DealerLookupModalProps> = ({
  setDealerExternalId,
  dealerExternalId,
  dealers,
  aemBaseUrl,
}) => {
  const DEALER_DIRECTORY = "resources/dealer-directory";
  const { aemContent } = useAem(
    DEALER_DIRECTORY,
    "dealer-directory",
    aemBaseUrl,
  );

  const [isOpen, setIsOpen] = useState<boolean>(dealerExternalId === "");

  const [searchValues, setSearchValues] = React.useState<IValue>({
    inputValue: "",
    selectedValue: "",
  });

  if (!aemContent) return <></>;

  // @ts-expect-error data is not recognized on aemContent
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
  const componentRefs = aemContent?.data?.componentRefs;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
  const fieldReferenceProps =
    componentRefs["tab-container-1"].props.tabs[0].items[15];

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const dealerResults = dealers.map((dealer) => {
    return { label: dealer.contactInfo.name, value: dealer.externalId };
  });

  const hitGroups: HitGroup[] = [
    {
      label: "",
      hits: dealerResults
        .filter((dealer) =>
          dealer.label
            .toLowerCase()
            .includes(searchValues.inputValue.toLowerCase()),
        )
        .slice(0, 50),
    },
  ];

  const modalHeader = fieldReferenceProps?.fieldReference[0] as AemFeatureText;
  const modalSearch = fieldReferenceProps
    ?.fieldReference[1] as DropdownContainer;
  const modalContinue = fieldReferenceProps?.fieldReference[2] as AemButton;

  const onModalContinue = () => {
    const hitGroupArray = hitGroups[0].hits;
    const selectedDealer = hitGroupArray.find(
      (dealer) => dealer.label === searchValues.selectedValue,
    );

    setDealerExternalId(selectedDealer!.value);
    handleCloseModal();
  };

  return (
    <ModalWindow variant={"large"} isOpen={isOpen} onClose={handleCloseModal}>
      <ModalHeader
        headingLevel={"h2"}
        onClose={handleCloseModal}
        data-testid={"modal-header"}
      >
        {removeAllHtmlTags(modalHeader.heading!)}
      </ModalHeader>
      <ModalBody>
        <div style={{ paddingLeft: "2px", marginBottom: "350px" }}>
          <Search
            labelProp={{ label: removeAllHtmlTags(modalHeader.text) }}
            data-testid={"modal-search"}
            name="dealer-search"
            placeholder={modalSearch.heading}
            searchResults={hitGroups}
            value={searchValues}
            onChange={(value) => {
              setSearchValues(value);
            }}
          />
        </div>
      </ModalBody>
      <ModalFooter placement="right">
        <Button
          onClick={onModalContinue}
          aria-label={modalContinue.ariaLabel}
          isDisabled={
            searchValues.selectedValue === "" || searchValues.inputValue === ""
          }
        >
          {modalContinue.buttonText}
        </Button>
      </ModalFooter>
    </ModalWindow>
  );
};
